import { Injectable } from '@angular/core';

@Injectable()
export class MathService {

    public sortArrayExceptOne(array: string[], exceptionalString: string): string[]
    {
        return array?.sort(function (a, b) { if(a === b) return 0; if (a === exceptionalString) return -1; if (b === exceptionalString) return 1; if (a < b) return -1; if (a > b) return 1; return 0; });
    }
}
